<template>
  <div class="loader-buttons">
    <button
      v-for="(button, index) in buttons"
      :key="index"
      :class="{ selected: selectedButton === index }"
      @click="selectButton(index)"
    >
      {{ button }}
    </button>
  </div>
</template>

<script>
export default {
  name: "MobileLoaders",
  props: {
    isMobileload: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      buttons: ["Stats", "Sources", "Countries"],
      selectedButton: 0,
    };
  },
  mounted() {
    console.log("MobileLoaders component mounted");
    this.$emit("button-selected", this.selectedButton);
  },
  methods: {
    selectButton(index) {
      console.log("Button clicked:", index);
      this.selectedButton = index;
      this.$emit("button-selected", index);
    },
  },
};
</script>

<style>
.loader-buttons {
  display: flex;
  /* flex-direction: row; */
  flex-wrap: wrap;
  gap: 12px;
  margin: 16px 0;
}

.loader-buttons button {
  font-size: 16px;
  font-weight: 600;
  padding: 11px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
}

.loader-buttons button.selected {
  border: none;
  background: white;
  border-radius: 25px;
  color: #1b193c;
  outline: none;
}
</style>